import { Form } from "antd"
import { useCallbackRef } from "../../../../hooks/use-callback-ref.ts"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import { useEffect } from "react"

import { isFormChanged } from "../../../../utils/object/is-form-changed.ts"
import type { SettingProfileFormData } from "../../types/types.ts"

interface SettingsProfileFormChangedWatcherProps {
  form: FormInstance<SettingProfileFormData>
  initialValues: SettingProfileFormData
  setIsDirty: (value: boolean) => void
  saving: boolean
}

export function SettingsProfileFormChangedWatcher({
  form,
  initialValues,
  setIsDirty,
  saving
}: SettingsProfileFormChangedWatcherProps) {
  const values = Form.useWatch([], form)
  const getAvatarUrl = (logo: SettingProfileFormData["avatar"]) =>
    typeof logo === "string" ? logo?.split("?")?.[0] : logo

  const setIsDirtyLatest = useCallbackRef(setIsDirty)
  useEffect(() => {
    const isChanged = isFormChanged<SettingProfileFormData>(
      { ...values, avatar: getAvatarUrl(values?.avatar) },
      { ...initialValues, avatar: getAvatarUrl(initialValues?.avatar) }
    )

    setIsDirtyLatest(isChanged)
  }, [values, saving, setIsDirtyLatest, initialValues])

  return null
}
